<div id="container-mat-spinner">
    <mat-spinner #matSpinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
</div>